import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const HeadlineDefaultProps = {
  ...ClassNameDefaultProps,
  brand: {},
  complementaryDescription: null,
  lengthName: false,
  name: null,
  range: null,
};

export const HeadlinePropTypes = {
  ...ClassNamePropTypes,
  brand: PropTypes.shape({
    name: PropTypes.string,
  }),
  complementaryDescription: PropTypes.string,
  lengthName: PropTypes.bool,
  name: PropTypes.string,
  range: PropTypes.string,
};
